import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const installmentScheduleReducer = (
  state = initialState.installmentScheduleData,
  action
) => {
  switch (action.type) {
    case types.FETCH_INSTALLMENT_SCHEDULE_ACCOUNTS_STARTED:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          accountNumbers: null,
          isLoading: true,
          error: null
        }
      };
    case types.FETCH_INSTALLMENT_SCHEDULE_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          accountNumbers: action.payload,
          isLoading: false,
          error: null
        }
      };
    case types.FETCH_INSTALLMENT_SCHEDULE_ACCOUNTS_FAILED:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          accountNumbers: null,
          isLoading: false,
          error: action.payload
        }
      };
    case types.FETCH_INSTALLMENT_SCHEDULE_DETAILS_STARTED:
      return {
        ...state,
        details: {
          ...state.details,
          accountDetails: null,
          isLoading: true,
          error: null
        }
      };
    case types.FETCH_INSTALLMENT_SCHEDULE_DETAILS_SUCCEEDED:
      return {
        ...state,
        details: {
          ...state.details,
          accountDetails: action.payload,
          isLoading: false,
          error: null
        }
      };
    case types.FETCH_INSTALLMENT_SCHEDULE_DETAILS_FAILED:
      return {
        ...state,
        details: {
          ...state.details,
          accountDetails: null,
          isLoading: false,
          error: action.payload
        }
      };
    default:
      return state;
  }
};

export default installmentScheduleReducer;
